import React from 'react';
import statusBar from "../../asset/images/certificates/status-bar.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Status(){
    return(

        <div className="status col-sm-12 col-md-6 col-lg-6">
                        <div className="card-box">
                            <div className="card-title">
                                <h2>Status</h2>
                            </div>
                            <div className="status-content">
                                <div className="status-img-bar">
                                    <img src={statusBar} alt="status-bar" className="status-img" />
                                </div>
                                <div className="status-label-wrapper">
                                    <div className="status-label">
                                        <span className="status-value-label">Completed</span>
                                        <span className="status-value">05</span>
                                    </div>
                                    <div className="status-label">
                                        <span className="status-value-label">In Progress</span>
                                        <span className="status-value">07</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    )
}
export default Status;